<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">{{ id === 'new' ? 'Novo vídeo' : 'Alterar vídeo' }}</div>
        <div @click="$router.push('/educational-video')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent="save" class="form">
        <Selector v-model="active" :options="activeOptions" class="selector_change"/>

        <label>Plataforma</label>
        <select v-model="platform" class="platform-select" :class="{ error: error.includes('platform') }">
          <option value="">Selecione a plataforma</option>
          <option v-for="opt in platformOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
        </select>
        <div v-if="error.includes('platform')" class="hint">selecione a plataforma</div>

        <label>Título</label>
        <input v-model="title" type="text" placeholder="Título do vídeo" :class="{ error: error.includes('title') }" />
        <div v-if="error.includes('title')" class="hint">informe o título</div>

        <label>URL do YouTube</label>
        <input v-model="youtubeUrl" type="url" placeholder="https://www.youtube.com/watch?v=..." :class="{ error: error.includes('youtubeUrl') }" />
        <div v-if="error.includes('youtubeUrl')" class="hint">informe uma URL válida do YouTube</div>

        <label>Ordem de exibição</label>
        <input v-model.number="sortOrder" type="number" min="0" step="1" style="max-width: 120px" />

        <div class="actions">
          <button @click="$router.push('/educational-video')" type="button" class="button-previous"><i class="fas fa-angle-left"></i><span>Cancelar</span></button>
          <button type="submit" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Salvar</span></button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { get, create, update } from '../api/educationalVideo'
import Selector from './Selector'

const PLATFORM_OPTIONS = [
  { value: 'profit', text: 'Profit' },
  { value: 'blackarrow', text: 'BlackArrow' },
  { value: 'ninjatrader', text: 'NinjaTrader' },
  { value: 'tradingview', text: 'TradingView' },
  { value: 'dashboard', text: 'Dashboard' },
  { value: 'profit_yan', text: 'Profit Yan' },
  { value: 'blackarrow_yan', text: 'BlackArrow Yan' },
  { value: 'ninjatrader_yan', text: 'NinjaTrader Yan' }
]

export default {
  name: 'EducationalVideo',
  components: { Selector },
  props: ['id'],
  data () {
    return {
      loading: false,
      error: [],
      platform: '',
      title: '',
      youtubeUrl: '',
      active: true,
      sortOrder: 0,
      platformOptions: PLATFORM_OPTIONS,
      activeOptions: [
        { value: true, text: 'ATIVO' },
        { value: false, text: 'INATIVO' }
      ]
    }
  },
  async mounted () {
    if (this.id !== 'new') {
      try {
        const v = await get(this.id)
        this.platform = v.platform || ''
        this.title = v.title || ''
        this.youtubeUrl = v.youtubeUrl || ''
        this.active = v.active !== false
        this.sortOrder = v.sortOrder != null ? v.sortOrder : 0
      } catch (e) {
        logger.error(e, this)
      }
    }
  },
  methods: {
    validate () {
      this.error = []
      if (!this.platform) this.error.push('platform')
      if (!this.title || !this.title.trim()) this.error.push('title')
      const url = (this.youtubeUrl || '').trim()
      if (!url || !/youtube\.com|youtu\.be/i.test(url)) this.error.push('youtubeUrl')
      return this.error.length === 0
    },
    async save () {
      if (!this.validate()) return
      this.loading = true
      try {
        const payload = [
          this.platform,
          this.title.trim(),
          this.youtubeUrl.trim(),
          this.active,
          this.sortOrder != null ? this.sortOrder : 0
        ]
        if (this.id === 'new') {
          await create(...payload)
        } else {
          await update(this.id, ...payload)
        }
        this.$router.push('/educational-video')
      } catch (e) {
        if (e.response && e.response.data && e.response.data.fields) {
          this.error = e.response.data.fields
        } else {
          this.error.push('internal')
        }
        logger.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
